import React from 'react';
import './Home.css'
import { Carousel } from 'react-bootstrap';
import slider1 from '../../../../images/slider/slider-1.jpg'
import slider2 from '../../../../images/slider/slider-2.jpg'
import slider3 from '../../../../images/slider/slider-3.jpg'
import Service from '../Service/Service';
import Works from '../Works/Works';
import useServices from '../../../../Hooks/useServices';

const Home = () => {
  const [services] = useServices();
  return (
    <div className='container'>
      <Carousel fade>
  <Carousel.Item>
    <img
      className="d-block w-100"
      src={slider1}
      alt="First slide"
    />
    <Carousel.Caption>
      <h3>Studio Photo Session</h3>
      <p>I am an artist and photographer</p>
    </Carousel.Caption>
  </Carousel.Item>
  <Carousel.Item>
    <img
      className="d-block w-100"
      src={slider2}
      alt="Second slide"
    />

    <Carousel.Caption>
      <h3>Outdoor Photo Session</h3>
      <p>I am an artist and photographer.</p>
    </Carousel.Caption>
  </Carousel.Item>
  <Carousel.Item>
    <img
      className="d-block w-100"
      src={slider3}
      alt="Third slide"
    />

    <Carousel.Caption>
      <h3>Wedding Photo Session</h3>
      <p>I am an artist and photographer</p>
    </Carousel.Caption>
  </Carousel.Item>
</Carousel>
<Works/>

<div className='container services_area'>
<h3>Services & Pricing</h3>
      <p>Please choose your package</p>
   <div className="row">
   {services.map(service => <Service key={service.id} service={service} />)}
   </div>
 </div>


    </div>
  );
};

export default Home;